export enum WarningLevel {
    Yellow = 'yellow',
    Orange = 'orange',
    Red = 'red',
    Black = 'black',
}

export interface CellWarningIndicatorProps {
    level?: WarningLevel;
}
